"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Player = (function () {
    function Player(boardPiece, canvas) {
        this.boardPiece = boardPiece;
        this.canvas = canvas;
    }
    return Player;
}());
exports.Player = Player;

//# sourceMappingURL=player.js.map
